import TableRowIconActions from '../../../components/shared/TableRowIconActions';
import { saleRowLeft } from './salePaymentUtils';

export default function SaleHistoryRowActions({
  row,
  onReceipt,
  onPayBalance,
  onEdit,
  onDelete,
}) {
  const left = saleRowLeft(row);

  return (
    <TableRowIconActions
      onEdit={onEdit ? () => onEdit(row) : undefined}
      onDelete={onDelete ? () => onDelete(row) : undefined}
      editLabel={`Edit ${row.member || 'sale'}`}
      deleteLabel={`Delete ${row.member || 'sale'}`}
    >
      {onReceipt ? (
        <button
          type="button"
          className="owner-btn owner-btn-secondary owner-btn-sm"
          onClick={() => onReceipt(row)}
        >
          Receipt
        </button>
      ) : null}
      {left > 0 && onPayBalance ? (
        <button
          type="button"
          className="owner-btn owner-btn-primary owner-btn-sm"
          onClick={() => onPayBalance(row)}
        >
          Pay balance
        </button>
      ) : null}
    </TableRowIconActions>
  );
}
